import { FC } from 'react';
// components
import AddSweetenerSystem from 'components/main/SweetenerSystem/Edit';

const AddSweetenerSystems: FC = () => <AddSweetenerSystem />;

export default AddSweetenerSystems;
